import styled from 'styled-components';

export const StyledQmarkCheckboxes = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 15px;
  font-family: ${(props) => props.theme.fontText};
  border-bottom: 1px solid ${(props) => props.theme.lightGrayBorder};

  .ant-checkbox-wrapper-in-form-item {
    font-family: ${(props) => props.theme.fontText};
  }

  .ant-checkbox-wrapper {
    font-family: ${(props) => props.theme.fontText};
  }

  .filter-single-checkbox {
    &.ant-form-item {
      margin-bottom: 0;
      padding-bottom: 15px;
    }
  }

  .qmarks-filter-checkboxes {
    display: flex;
    flex-direction: column;
    font-weight: 500;
    font-size: 16px;
    padding-left: 25px;

    .qmark {
      display: flex;
      flex-wrap: wrap;

      .ant-form-item {
        margin: 0;
        min-width: 100%;
      }
    }
  }

  .qmark-filter-title {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    align-items: center;
    padding-bottom: 15px;
    font-weight: 600;
    gap: 10px;
    cursor: pointer;

    .icon {
      display: flex;
      font-size: 14px;
      align-items: center;
      transform: rotate(0deg);
      transition: transform 0.2s ease;
      &.collapsed {
        transform: rotate(-90deg);
      }
    }
  }

  &:last-child {
    border-bottom: none;
  }
`;
